import classNames from 'classnames'
import { useContactCodesStatus } from 'legacy/lut/components/widgets/public/useHooks/useContactCodesStatus'
import React, { useEffect, useState } from 'react'

import { TPopupHorizontal } from 'core-components/library/popup'
import { Tooltip } from 'core-components/library/tooltip'

import { normalizeIndicatorStatus } from './helpers/normalizeIndicatorStatus'

import styles from './ContactTicketIcon.module.scss'

interface IProps {
  item: IObjectAny
}

export const ContactTicketIcon = ({ item }: IProps) => {
  const [indicatorStatus, setIndicatorStatus] = useState('')

  const {
    ContactId: contactId,
    TicketStatus: ticketStatus,
    TicketSubject: ticketSubject,
    RequestAction: ticketAction,
    ContactCodeStatus: codeStatus,
  } = item

  const otherCodesStatus = useContactCodesStatus(
    codeStatus && codeStatus !== 'Done' ? contactId : ''
  )

  useEffect(() => {
    if (ticketStatus && ticketStatus !== 'Done') {
      setIndicatorStatus(ticketStatus)
    } else if (codeStatus && codeStatus !== 'Done') {
      setIndicatorStatus(codeStatus)
    } else {
      setIndicatorStatus('')
    }
  }, [contactId, ticketStatus, codeStatus])

  if (!indicatorStatus) {
    return <div className={styles.requestIndicator} />
  }

  return (
    <Tooltip
      className={styles.requestIndicator}
      horizontalStartPosition={TPopupHorizontal.Right}
      horizontalDirection={TPopupHorizontal.Right}
      tipContent={() => (
        <div className={styles.requestIndicatorTipContent}>
          {ticketStatus ? (
            ticketSubject ? (
              <>
                <p>{`Ticket Action: ${ticketAction}, Status: ${ticketStatus}`}</p>
                <p>{`${ticketSubject}`}</p>
              </>
            ) : (
              <p>{`Ticket Action: ${ticketAction}, Status: ${ticketStatus}`}</p>
            )
          ) : null}
          {codeStatus && !otherCodesStatus ? <p>{`Contact Code Status: ${codeStatus}`}</p> : null}
          {otherCodesStatus ? (
            <>
              {otherCodesStatus['UserRights'] ? (
                <p>{`UserRights Status: ${otherCodesStatus['UserRights']}`}</p>
              ) : null}
              {otherCodesStatus['Campaigns'] ? (
                <p>{`Campaigns Status: ${otherCodesStatus['Campaigns']}`}</p>
              ) : null}
              {otherCodesStatus['Tools'] ? (
                <p>{`Tools Status: ${otherCodesStatus['Tools']}`}</p>
              ) : null}
            </>
          ) : null}
        </div>
      )}
    >
      <div
        className={classNames(
          styles.requestIndicator,
          styles[`requestIndicator${normalizeIndicatorStatus(indicatorStatus)}`]
        )}
      >
        <div className={styles.requestIndicatorItem} />
      </div>
    </Tooltip>
  )
}
